// -----------------------------------------------------------------------------
// Scripts for slider
// -----------------------------------------------------------------------------

$(function () {
  const sliders = $('.logo-slider');

  $.each(sliders, function(index, value) {
    const singleSlider = $(this).find('.logo-slider__content').attr('id');

    $(`#${singleSlider}`).slick({
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
      ]
    });
  });
});